export default __webpack_public_path__ + "static/media/fotogold2.5483166d.png";